export default __webpack_public_path__ + "static/media/img1234.4d9757de.jpg";